<template>
    <div>
        <v-card>
            <v-card-text>
                <v-card-title class="titulopagina">LISTADO  DE  FOLIOS PCC4</v-card-title>
            </v-card-text>
        </v-card>

        <v-card class="mt-2">
            <tabla-paginada @cargar="cargar($event)">
                <template v-slot:conforme_nc="props">
                    <v-checkbox :input-value="props.item.conforme_nc"
                                @change="updateConformeNc(props.item)"
                                label="conforme/nc">
                    </v-checkbox>
                </template>
            </tabla-paginada>
        </v-card>
    </div>
</template>
<script>
import {mapMutations, mapState} from 'vuex';
import TablaPaginadaVue from '../../components/shared/TablaPaginada.vue';

export default {
    data: () => ({
        lista: [],
        links: [],
        columnas: [
            {
                nombre: 'Folio PCC4',
                key: 'folio_pcc4',
                path: 'folio_pcc4',
                tipo: 'texto',
                busqueda: '',
                searchable: false
            },
            {
                nombre: 'Conforme/NC',
                key: 'conforme_nc',
                path: 'conforme_nc',
                tipo: 'boolean',
                busqueda: '',
                searchable: false
            },
            {
                nombre: 'Cantidad Despachos',
                key: 'cant_despachos',
                path: 'cant_despachos',
                tipo: 'numero',
                busqueda: '',
                searchable: false
            },
            {
                nombre: 'Usuario Conforme',
                key: 'name',
                path: 'user.name',
                tipo: 'texto',
                busqueda: '',
                searchable: false
            },
            {
                nombre: 'Fecha Conforme',
                key: 'fecha_conforme',
                path: 'fecha_conforme',
                tipo: 'datetime',
                busqueda: '',
                searchable: false
            },
        ],
    }),
    mounted() {
        this.cargar('?tipo_produccion_id=1&limit=10');
    },
    methods: {
        updateConformeNc(item) {
            const dateObj = new Date()
            const dateFormatted = dateObj.getDate()+"/"+dateObj.getMonth()+"/"+dateObj.getFullYear()
            this.axios.put(`${this.base_url}despacho_pcc4/${item.id}`, {
                conforme_nc: !item.conforme_nc,
            },this.headers).then((res) => {
                this.cargar('?tipo_produccion_id=1&limit=10');
            }).catch((e) => {
                console.log(e);
            })
        },
        async cargar(query) {
            await this.axios.get(`${this.base_url}despacho_pcc4${query}`, this.headers).then((res) => {
                console.log('res', res);
                this.lista = res.data.data;
                this.actualizarTablaPaginada({
                    columnas: this.columnas,
                    lista: this.lista,
                    total_paginas: res.data.data.last_page
                })
            }).catch((e) => {
                console.log(e);
            })
        },

        ...mapMutations(['actualizarTablaPaginada', 'mostrarLoading', 'ocultarLoading'])
    },
    computed: {
        ...mapState(['base_url', 'headers'])
    },
    components: {
        'tabla-paginada': TablaPaginadaVue
    }
}
</script>
